export default "__VITE_ASSET__DLGXKJ6o__"